import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

// import usePrivateLink from "../config/usePrivateLink";
// import { useNavigate, useLocation } from "react-router-dom";

// const DocumentHeader = ({ data }) => {
//     const navigate = useNavigate();
//     const location = useLocation();

//  const tabs = [
//   {
//     id: "enquiryAdd",
//     title: "Documents Category",
//     icon: "fa-solid fa-folder-tree",        // Categories ko represent karta hai
//     path: "/documents/category"
//   },

//   {
//     id: "todayreport",
//     title: "Documents Collection",
//     icon: "fa-solid fa-file-arrow-up",      // File collect/upload meaning
//     path: "/documents/collection"
//   },

//   {
//     id: "enquiryfoloup",
//     title: "Documents Distribution",
//     icon: "fa-solid fa-file-arrow-down",    // File distribute/download meaning
//     path: "/documents/distribution"
//   }
// ];

//     return (
//         <div className="">
//             <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
//                 <h5 className="text-primary text-center p-2">{data}</h5>
//                 {tabs.map((tab) => {
//                     const isActive = location.pathname === tab.path;
//                     return (
//                         <button
//                             key={tab.id}
//                             className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "active" : ""
//                                 }`}
//                             onClick={() => navigate(tab.path)}
//                         >
//                             <i className={`${tab.icon} me-2`} />
//                             {tab.title}
//                         </button>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// export default DocumentHeader;


const DocumentHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
    {
      id: "enquiryAdd",
      title: "Category",
        icon: "ri-folder-2-line",  // Categories ko represent karta hai
      path: "/documents/category",
    },

    {
      id: "todayreport",
      title: "Collection",
      icon: "ri-file-upload-line", // File collect/upload meaning
      path: "/documents/collection",
    },

    {
      id: "enquiryfoloup",
      title: "Distribution",
      icon: "ri-file-download-line", // File distribute/download meaning
      path: "/documents/addistribution",
    },
  ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <div className="">
      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">
            You don't have permission to access any tabs.
          </div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${
                isActive ? "bg-label-primary" : ""
              } ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default DocumentHeader;
